import React, { useEffect, useState } from "react";

const clave = (id) => `guiaAws.nota.${id}`;
const leer = (id) => { try { return localStorage.getItem(clave(id)) || ""; } catch (e) { return ""; } };

// Notas personales por servicio, guardadas solo en este navegador
const Notas = ({ id, titulo }) => {
    const [texto, setTexto] = useState(() => leer(id));
    useEffect(() => { setTexto(leer(id)); }, [id]);
    const cambiar = (v) => { setTexto(v); try { if (v) localStorage.setItem(clave(id), v); else localStorage.removeItem(clave(id)); } catch (e) { /* sin almacenamiento */ } };
    return (
        <div className="card mb-3 no-imprimir" data-guia="notas">
            <div className="card-header"><b><i className="fa fa-sticky-note me-2 text-warning" />Mis notas sobre {titulo}</b></div>
            <div className="card-body">
                <textarea className="form-control" rows={3} value={texto} onChange={e => cambiar(e.target.value)} placeholder="Escribe aquí lo que quieras recordar. Se guarda solo en este navegador." aria-label={`Notas sobre ${titulo}`} />
            </div>
        </div>
    );
};

export default Notas;
